import { render, staticRenderFns } from "./IosTop.vue?vue&type=template&id=2e4be786&scoped=true&"
import script from "./IosTop.vue?vue&type=script&lang=js&"
export * from "./IosTop.vue?vue&type=script&lang=js&"
import style0 from "./IosTop.vue?vue&type=style&index=0&id=2e4be786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4be786",
  null
  
)

component.options.__file = "IosTop.vue"
export default component.exports